import { Address } from './address';

export enum StatusTypes {
  CANCELLED = 'Anulada',
  BLOCKED = 'Bloqueada',
  OPERATIVE = 'Operativa',
  NO_KEY = 'Sin Clave',
  PENDING = 'Pdte. Envío',
  SENT = 'Enviada'
}

export enum ProfileProduct {
  MODIFIED = 'Mi Perfil - Clave firma modificar',
  ASK = 'Mi Perfil - Clave firma Solicitar',
  CANCEL = 'Mi Perfil - Clave firma anular'
}

export enum ParticularProfileErrorCodes {
  GENERIC_ERROR = 'GENERIC_ERROR',
  CREDENTIALS_ERROR = 'CLIENT_AREA.LOGIN.INVALID_CREDENTIALS',
}

export interface SecurityQuestion {
  question: string;
  answer: string;
}

export interface Question {
  code: number;
  question: string;
}

export interface UpdatePassword {
  newPassword: string;
  oldPassword: string;
}

export interface UpdateSecurityQuestion {
  password: string;
  question: SecurityQuestion;
}

export interface ProfileUserInfo {
  name: string;
  lastname: string;
  lastname2: string;
  documentNumber: string;
  documentType: string;
  birthdate: string;
  email: string;
  phones: string[];
  address: Address;
  securityQuestion: SecurityQuestion;
  treatment: string;
  signingKeyStatusDescription: string;
  signingKeyStatus: string;
  signingKeyLastModified: string;
  contractAcceptanceDate: string;
}

export interface ProfileBusinessInfo {
  name: string;
  documentNumber: string;
  documentType: string;
  address: Address;
  legalRepresentative: {
    name: string;
    surname1: string;
    surname2: string;
    phone: string;
    email: string;
    birthdate: string;
    documentNumber: string;
    documentType: string;
  };
}

export interface UpdateBusinessLegalRepresentative {
  name: string;
  surname1: string;
  surname2: string;
  email: string;
  birthdate: string;
}

export interface ContactInfoField {
  email?: string;
  phones?: string[];
  streetType?: string;
  street?: string;
  number?: string;
  door?: string;
  stair?: string;
  floor?: string;
  additionalInfo?: string;
  postalCode?: string;
  locality?: string;
  province?: string;
}

export interface ProfileValidationResult {
  businessId: string;
  token: string;
}

export interface SigningKey {
  position: number;
  value?: string;
}

export interface SigningKeyPositions {
  positions: SigningKey[];
}

export interface SigningKeyUpdate {
  key: string;
  currentKeyPositions?: SigningKey[];
}

export interface ProfileError {
  code: string;
  description: string;
}

export const DefaultRequiredPositions: SigningKey[] = [
  { position: 1 },
  { position: 2 },
  { position: 3 },
  { position: 4 },
  { position: 5 },
  { position: 6 },
  { position: 7 },
  { position: 8 }
];
